// extracted by mini-css-extract-plugin
export var quillEditor = "_gn-1";
export var variable = "_gn-0";